import { render, staticRenderFns } from "./ProjectSummaryOvertime.vue?vue&type=template&id=2049e112"
import script from "./ProjectSummaryOvertime.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryOvertime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports